/**
 * Re-aggregate the backend's finest-grain breakdown (per ticket type + option)
 * into whatever grouping the active breakdown checkboxes require. Shared by the
 * cancelled/refunded report table and its xlsx export so the two stay in sync.
 *
 * - both off    -> [] (no breakdown rows)
 * - type only   -> one row per ticket type, options collapsed
 * - option only -> one row per ticket option, types collapsed
 * - both on     -> one row per type+option combination (backend rows as-is)
 */
export function aggregateBreakdown(breakdown, showType, showOption) {
    if (!showType && !showOption) return [];

    const grouped = new Map();
    for (const bd of breakdown) {
        let key;
        if (showType && showOption) {
            key = `${bd.ticketTypeId ?? 'none'}-${bd.ticketOptionId ?? 'none'}`;
        } else if (showType) {
            key = `type-${bd.ticketTypeId ?? 'none'}`;
        } else {
            key = `option-${bd.ticketOptionId ?? 'none'}`;
        }

        const existing = grouped.get(key);
        if (existing) {
            existing.itemCount += bd.itemCount;
            existing.totalAmount += bd.totalAmount;
        } else {
            grouped.set(key, {
                key,
                ticketTypeName: showType ? (bd.ticketTypeName ?? '-') : null,
                ticketOptionName: showOption ? (bd.ticketOptionName ?? '-') : null,
                itemCount: bd.itemCount,
                totalAmount: bd.totalAmount,
            });
        }
    }
    return [...grouped.values()];
}

export default aggregateBreakdown;
